import React from "react";
import cx from "classnames";

import "./OrderSummary.css";
import CMSContent from "../CMSContent/CMSContent";

const OrderSummary = props => {
  const { title, total, sum, country, endDate, footnote } = props;
  const cartSummaryBoxStyle = cx({
    "cart-summary-box": true,
    "d-flex": true,
    "flex-fdc": true,
    "flex-jc": true,
    "w-100": true,
    "pad-16": true,
    "border-box": true
  });
  const tax = Number((sum * 0.2).toFixed(2));
  return (
    <div className={cartSummaryBoxStyle}>
      <div className="ta-center fs-14 fw-normal lh-md c-black-60 ff-ns">
        {title} (<span className="total fw-strong">{total} items</span>)
      </div>
      {country !== "GB" && (
        <div className="ta-center fs-18 fw-normal lh-lg c-black-60 ff-ns">
          {`$${sum.toFixed(2)}`}
        </div>
      )}
      {country === "GB" && (
        <div className="uk-info fs-14">
          <div className="price-table pad-h-16">
            <div className="d-flex flex-jsb">
              <div className="ta-left fw-bold">Sub-Total:</div>
              <div className="ta-right">{`$${sum.toFixed(2)}`}</div>
            </div>
            <div className="d-flex flex-jsb">
              <div className="ta-left fw-bold">Tax:</div>
              <div className="ta-right">{`$${tax.toFixed(2)}`}</div>
            </div>
            <div className="d-flex flex-jsb">
              <div className="ta-left fw-bold">Total:</div>
              <div className="ta-right">{`$${(sum + tax).toFixed(2)}`}</div>
            </div>
          </div>
          <div className="pad-t-16 ta-center">
            <CMSContent id={76} />
          </div>
        </div>
      )}
      {!!footnote && <div className="pad-t-4 ta-center fs-12 lh-sm">
        {footnote}
      </div>}
    </div>
  );
};

export default OrderSummary;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/OrderSummary/OrderSummary.js